import { clientPromise } from '../../../../http/apollo.config';
import { CHECK_REFERRAL_CODE } from '../../../../http/apollo-queries';

let checkCount = 0;
let lastCode = '';
const maxCheckCount = 30;

export const ReferralCodeValidator = (referralCode: string) => {
  if (!referralCode) {
    return null;
  } else if (referralCode.length >= 1 && referralCode.length < 22) {
    return 'Invalid';
  } else if (referralCode.length > 22) {
    return 'Invalid';
  } else if (referralCode.substring(0, 3) === 'MRL-') {
    return 'Invalid';
  } else if (checkCount > maxCheckCount) {
    return 'TooManyCheck';
  } else {
    if (lastCode !== referralCode) {
      checkCount++;
      lastCode = referralCode;
    }

    return clientPromise
      .then((client) =>
        client
          .query({ query: CHECK_REFERRAL_CODE, variables: { referralCode } })
          .then((res) => {
            return res.data?.checkReferralCode?.status === 'SUCCESS'
              ? null
              : 'NotExist';
          })
      )
      .catch(() => {
        return 'Error';
      });
  }
};
